import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'

import * as ab from '../../store/ab'

/**
 * Displays children if the variation for the specified test is active.
 *
 * For original varation, do not specify the `variation` prop.
 */

const Experiment = ({isVisible, children}) => (isVisible ? children : null)

Experiment.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  test: PropTypes.string.isRequired,
  variation: PropTypes.number,
  children: PropTypes.node.isRequired,
}

const mapStateToProps = createStructuredSelector({
  isVisible: ab.isVariationActive,
})

export default connect(mapStateToProps)(Experiment)
